import { Displayable } from 'django-rest-react';

declare var __SITE_URL__: string;
declare var __DEBUG__: boolean;
declare var __SENTRY_USE_SENTRY__: boolean;
declare var __SENTRY_DSN__: string;
declare var __VERSION__: string;
declare var __THE_SENDING_MAIL__: string;
declare var __JEST_TESTING__: boolean;
declare var __DEFAULT_LOCALE__: string;


export const site_url: string = __SITE_URL__;
export const DEBUG = __DEBUG__;
export const SHOW_STORE_DEBUG = __JEST_TESTING__ ? false : DEBUG;
export const VERSION = __VERSION__;
export const PROJECT_NAME = "stagefisica";
export const THE_SENDING_MAIL = __THE_SENDING_MAIL__;
export const DEFAULT_LOCALE = __DEFAULT_LOCALE__;
export const TESTING = __JEST_TESTING__;



export const sentry_config = {
    use_sentry: __SENTRY_USE_SENTRY__,
    dsn: __SENTRY_DSN__,
    release: VERSION,
}


/*
 * Per formattare in modo uniforme le date.
 */
export const date_options = {
  weekday: 'long', year: 'numeric', month: 'long',
  day: 'numeric', hour: 'numeric', minute: 'numeric',
  timeZone: "Europe/Rome"
};


export {
  DOMANDAISCRIZIONE_CLASSI as CLASSI,
  DOMANDAISCRIZIONE_PARTECIPAZIONE_SENIGALLIA as MEDAGLIE_SENIGALLIA,
  SCUOLA_TIPI_SCUOLA as TIPOLOGIE_SCUOLA,
} from './auto-enums'


export const login_url = (redir?: string) => {
    const trgt = !!redir ? redir : window.location.hash.replace("#", "%23");
    window.location.assign(`${window.location.origin}/accounts/login/?next=/${trgt}`)
}

// Questo deve essere sincronizzato con problems/models.py:DECIMAL_PLACES
export const DECIMAL_PLACES = 0.00001;


export const YESNO: Displayable[] = [
  {id: 'y', display: "Sì"},
  {id: 'n', display: "No"},
]

export const EDITABLE_STATES = [
  "ppt", "ppo",
]

export const MESSAGGI_STATO_ISCRIZIONE = {
  cpt: "Hai consegnato il pretest. Attendi qualche giorno per sapere se lo hai superato o meno e il tuo punteggio.",
  fpt: "Ci dispiace comunicarti che hai ottenuto un punteggio non sufficiente per qualificarti alla fase successiva. Speriamo tu ritenti l'anno prossimo. Ricorda che puoi comunque consultare il materiale fornito ai ragazzi, essendo pubblico su questo sito.",
  ppt: "Hai superato il pretest. Controlla il testo dei problemi dell'esame scritto appena vengono pubblicati e torna su questa pagina per consegnare il tuo elaborato.",
  cts: "Hai consegnato l'esame scritto. Lo stiamo correggendo, torna fra qualche giorno per vedere il tuo punteggio, le correzioni e se lo hai superato o meno",
  fts: "Ci dispiace comunicarti che hai ottenuto un punteggio non sufficiente per qualificarti alla fase successiva. Speriamo tu ritenti l'anno prossimo. Ricorda che puoi comunque consultare il materiale fornito ai ragazzi, essendo pubblico su questo sito.",
  pts: "Hai superato la prova scritta, sei stato selezionato per sostenere l'esame orale. Su questa pagina troverai l'orario proposto per il tuo esame orale, che dovrebbe esserti stato comunicato anche per email. Congratulazioni, sei già fra i migliori ad aver tentato questa ammissione.",
  fpo: "Ci dispiace comunicarti che non sei fra i 24 selezionati dopo la prova orale. Speriamo tu ritenti l'anno prossimo. Ricorda che puoi comunque consultare il materiale fornito ai ragazzi, essendo pubblico su questo sito.",
  ppo: "Hai superato la prova orale, congratulazioni! Sei fra i 24 selezionati per partecipare. Per concludere il processo di ammissione devi accettare il posto usando questo form.",
  pr: "Hai rifiutato il posto offerto per partecipare allo stage, ci dispiace. Se vuoi, saremmo felici di sapere il motivo di questa scelta, puoi comunicarcelo per email.",
  pa: "Hai accettato il posto, la procedura di ammissione è terminata, congratulazioni. Ci vediamo a Pisa.",
}


export * from './display'
